
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","width":"9","height":"4"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('g',[_c('path',{attrs:{"fill":"#fff","d":"M0 4c.315-2.262 2.21-4 4.5-4S8.685 1.738 9 4H0z"}})])])])
          )
        }
      }
    